export default __webpack_public_path__ + "static/media/nx-alert-circle.f4cca081.svg";